import React, { useState } from 'react';
import Sidebar from './Layout/Sidebar';
import MobileBottomNav from './Layout/MobileBottomNav';
import MobileHeader from './Layout/MobileHeader';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <div className="flex h-screen overflow-hidden" style={{ background: 'var(--canvas)' }}>
      {/* Desktop Sidebar - Hidden on mobile */}
      <div className="hidden lg:flex lg:flex-shrink-0">
        <Sidebar isOpen={isSidebarOpen} onToggle={toggleSidebar} />
      </div>

      {/* Main Content Area */}
      <div className="flex-1 flex flex-col min-w-0 overflow-hidden">
        {/* NO DESKTOP HEADER.
            It carried a page title that 101 of the 112 pages already render for
            themselves, a Settings button and a name/role block that both exist
            in the sidebar footer, and two controls that now live there too. A
            full bar of height on every page for nothing of its own. */}

        {/* Its counterpart below lg. Not the same component: the desktop header
            carries a subtitle and a name/role block that leave no room for a
            title on a phone. */}
        <MobileHeader />

        {/* Main Content - Scrollable */}
        <main className="flex-1 overflow-y-auto">
          {/* Mobile: Add padding at bottom for bottom nav */}
          <div className="p-4 lg:p-6 pb-20 lg:pb-6">
            {children}
          </div>
        </main>
      </div>

      {/* Mobile Bottom Navigation - Only on mobile */}
      <MobileBottomNav />
    </div>
  );
};

export default Layout;
